import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  ICON_COLOR,
  ICON_HEIGHT_32,
  ICON_HEIGHT_40,
  IconNG,
  IconSpinnerOverlay,
} from '../../../Icon'
import { UploadImageStage } from '../../UploadImageStage'

import * as styles from './UploadImageModalStageArea.module.css'

import ErrorIcon from '../../../../icons/error.svg'

function UploadImageModalStageArea({
  cropShape,
  engine,
  isErrorState,
  isLoadingState,
  isMobileScreenSize,
  isSkeletonState,
  isSubmitting,
  stageRef,
}) {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        styles.stageArea,
        isMobileScreenSize && styles.stageAreaFullScreen
      )}
      ref={stageRef}
    >
      {isSkeletonState ? (
        <div className={styles.fullBleedStage} />
      ) : isErrorState ? (
        <div className={styles.statePanel}>
          <IconNG Icon={ErrorIcon} size={ICON_HEIGHT_32} />
          <span>{t('UploadImage.UploadErrorKey')}</span>
        </div>
      ) : isLoadingState ? (
        <div className={styles.statePanel}>
          <IconSpinnerOverlay
            color={ICON_COLOR.SecondaryTextColor}
            size={ICON_HEIGHT_40}
          />
        </div>
      ) : (
        <UploadImageStage
          crop={engine.crop}
          cropShape={cropShape}
          dragCursor={engine.dragCursor}
          hasImage={engine.hasImage}
          image={engine.image}
          isDisabled={isSubmitting}
          isDragging={engine.isDragging}
          layout={engine.layout}
          rotation={engine.rotation}
          onPointerDown={engine.onPointerDown}
          onPointerMove={engine.onPointerMove}
          onPointerUp={engine.onPointerUp}
        />
      )}
    </div>
  )
}

export default UploadImageModalStageArea
